export default "__VITE_ASSET__Rl$5J30P__"